import React from 'react'

import { Card, Stack, Title } from '@tidbcloud/uikit'

import { StatementModel } from '../../utils/type'
import { ListTable } from './ListTable'

export const PlansList: React.FC<
  React.PropsWithChildren<{
    data: StatementModel[]
    onPlanClick: (planDigest: string) => void
  }>
> = ({ data, onPlanClick }) => {
  return (
    <Card shadow='none' p='xl'>
      <Stack gap='xs'>
        <Title order={5}>Plan History</Title>

        <ListTable
          data={data}
          sortBy={[{ id: 'last_seen', desc: true }]}
          onPlanClick={onPlanClick}
        />
      </Stack>
    </Card>
  )
}
